var searchParams = new URLSearchParams(new URL(window.location.toString()).search);
var currentData = localStorage.getItem('utmData');
if (currentData === null || currentData === undefined) {
    currentData = [];
} else {
    currentData = JSON.parse(currentData);
}
var currentEntry = {
    date: new Date().toISOString(),
    utm: [],
};
searchParams.forEach((value, key) => {
    if (key.indexOf("utm") >= 0) { // As long as the key contains utm, it's of interest
        currentEntry.utm.push(key+"="+value); // We need both key and value, since utm parameters can be many different keys
    }
});
if (currentEntry.utm.length > 0) { // Only paste in, if we have any new data
    currentData.push(currentEntry)
}
localStorage.setItem('utmData', JSON.stringify(currentData));